import { createSlice } from '@reduxjs/toolkit';

interface State {
  mode: 'light' | 'dark';
}

const initialState: State = {
  mode: 'dark',
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    updateThemeMode: (state, action) => {
      state.mode = action.payload;
    },
  },
  extraReducers: {},
});

export const { updateThemeMode } = themeSlice.actions;
export default themeSlice.reducer;
